export const ADD_NEW_RTO ="ADD_NEW_RTO"
export const ADD_NEW_RTO_SUCCESS = "ADD_NEW_RTO_SUCCESS"
export const ADD_NEW_RTO_ERROR = "ADD_NEW_RTO_SUCCESS"